export default "__VITE_ASSET__D_yEw6Eq__"